import React, { FC } from 'react';
import { Icon } from './Icon';
import { Headline6 } from './Text';
import styled from 'styled-components';
import { FlexboxVertical } from './Layout';

const Wrapper = styled(FlexboxVertical)`
  margin: 5rem auto;
  
  & > *:first-child {
    align-self: center;
    margin-bottom: 1rem;
  }
`;

export const NoDataPlaceholder: FC = ({ children }) => {
  return (
    <Wrapper>
      <Icon icon={'state-warn'} size={32} />
      <Headline6>{ children }</Headline6>
    </Wrapper>
  );
}
